import React from "react";
import { useAdminAuth } from "../context/adminAuth";
import { Navigate, useLocation } from "react-router-dom";

const AdminProtectedRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAdminAuth()
    const location = useLocation()

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center">
                <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-blue-600"></div>
            </div>
        )
    }

    if (!isAuthenticated) {
        // Redirect to admin login with return path
        return <Navigate to='/admin/login' state={{ from: location }} replace />
    }

    return children
}

export default AdminProtectedRoute